export default __webpack_public_path__ + "static/media/configr-login.50d868cb.svg";